import React, { useState, useEffect } from 'react'
import LoadingScreen from 'react-loading-screen'
import logo from "assets/img/logo/logo_aig_login-2.png";
import { urlGuardarRecargoPymes, urlGuardarPasoFacturacionPymes, urlSolicitarRecotizacion } from 'constants/urls'
import { Card, CardBody, Row, Col, Button, CardTitle, Alert } from "reactstrap";
import { urlEliminarUbicacionPymes, urlEnviarCorreoPymes } from '../../constants/urls'
import { apiGet, apiPost } from '../../api'
import { Select } from "react-inputs-validation";
import { Checkbox } from "react-inputs-validation";
import makeAnimated from 'react-select/lib/animated';
import Select1 from 'react-select';
import '../../styles/estilos.css'
import Iframe from 'react-iframe';
import EmisionRetroactiva from './EmisionRetroactiva';
import moment from 'moment';
import ConfirmationModal from '../Modal/ConfirmationModal';

const Resumen = ({ resumen, idCarrito, redireccionar, editarUbicacion, editarCotizacion, editarCoberturas, anadirUbicacion, deshabilitar, correoEnviado = false, setCorreoEnviado, carUrlPdf = '', setCargarRecargo }) => {
  const [correo, setCorreo] = useState('');
  const [loading, setLoading] = useState(false);
  const [descuento, setDescuento] = useState(false);
  const [pulse, setPulse] = useState(!resumen.error);
  const [totales, setTotales] = useState(resumen ? resumen.totales : []);
  const [urlPdf, setUrlPdf] = useState('');
  const [mensaje, setMensaje] = useState(false);
  const [msjEmail, setMsjEmail] = useState(false);
  const [claseDivFix, setClaseDivFix] = useState('flex-row div-flotante');
  const [opciones, setOpciones] = useState([]);
  const [datoCambio, setdatoCambio] = useState('btn btn-primary');
  const [error, setError] = useState(resumen.error)
  const [ramfecFuturo, setRamfecFuturo] = useState(null)
  const [ramfecRetroactividad, setRamfecRetroactividad] = useState(null)
  const [requiereEmision, setRequiereEmision] = useState(false)
  const [vigenciaRetroactiva, setVigenciaRetroactiva] = useState(new Date())
  const [modal, setModal] = useState(false);
  const [idUbicacion, setIdUbicacion] = useState(null);
  const [actionButtons, setActionButtons] = useState([
    {
      title: "EDITAR UBICACIÓN",
      className: 'button-white',
      onclick: () => onClickEditarUbicacion(),
      icon: 'fa fa-edit'
    },
    {
      title: " EDITAR VALORES COTIZACIÓN",
      className: 'button-white',
      onclick: () => onClickEditarCotizacion(),
      icon: 'fa fa-edit'
    },
    {
      title: "AÑADIR/ELIMINAR COBERTURA",
      className: 'button-white',
      onclick: () => onClickEditarCoberturas(),
      icon: 'fa fa-edit'
    },
    {
      title: "AÑADIR UBICACIÓN",
      className: 'button-white',
      onclick: () => onClickAnadirUbicacion(),
      icon: 'fa fa-edit'
    }
  ])





  const [errorVigenciaRetroactiva, setErrorVigenciaRetroactiva] = useState(false)



  const onClickEditarCotizacion = async () => {
    setLoading(true)
    editarCotizacion()
    setLoading(false)
  }

  const onClickEditarCoberturas = async () => {
    setLoading(true)
    editarCoberturas()
    setLoading(false)
  }

  const onClickEditarUbicacion = async () => {
    setLoading(true)
    editarUbicacion()
    setLoading(false)
  }

  const onClickAnadirUbicacion = async () => {
    setLoading(true)
    anadirUbicacion()
    setLoading(false)
  }

  const onClickContinuar = async () => {
    setLoading(true)
    let param = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      paso: 7,
      idCarrito: idCarrito,
      fechaEmisionRetroactivaFutura: moment(new Date(vigenciaRetroactiva)).format('yyyy/MM/DD'),
      emisionRetroactivaFutura: requiereEmision
    }
    try {
      let res = await apiPost(urlGuardarPasoFacturacionPymes, param)
      if (res.transaccion) {
        redireccionar()
      }
    } catch (e) {
      alert('Ha ocurrido un error por favor intentar nuevamente')
    }
    setLoading(false)
  }

  const onSolicitarRecotizacion = async () => {
    setLoading(true)

    try {
      let res = await apiGet(urlSolicitarRecotizacion + idCarrito)
      if (res.transaccion) {
        alert('Se solocitó recotización')
        setCorreoEnviado(true)
      }
    } catch (e) {
      setCorreoEnviado(false)
    }
    setLoading(false)
  }

  const enviarEmail = async () => {

    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (reg.test(correo) == false) {
      setMsjEmail(true)
      setTimeout(() => setMsjEmail(false), 4000)
    } else {
      setLoading(true)
      const param = { idCarrito, correo, empresa: "AIGMETROPOLITANA", plataforma: "WEB", }
      const data = await apiPost(urlEnviarCorreoPymes, param)
      console.log(data)
      setLoading(false)
      setMensaje(true)
      setTimeout(() => setMensaje(false), 5000)
    }
  }
  useEffect(() => {

    let { opciones } = resumen
    if (opciones) {
      opciones.forEach((element, i) => (opciones[i] = { ...element, value: false }));
      setOpciones(opciones)
    }
    const { recargoDescuento } = resumen

    if (!deshabilitar || (deshabilitar && !correoEnviado)) {
      handleRecargo('0');
    }

    if (deshabilitar && correoEnviado) {

      setUrlPdf(carUrlPdf)
    }


    window.scroll(0, 0)
    return () => {
      // window.removeEventListener("scroll", handleScroll);
    }
  }, [])

  const handleScroll = () => {
    const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;

    if (windowBottom >= (docHeight - 300)) setClaseDivFix('flex-row div-flotante fix-botton-totales-resumen-multi')
    else setClaseDivFix('flex-row div-flotante')
  }

  /**
 * eliminarElemento - Función asíncrona para eliminar un elemento específico dado su idCotizacion y idUbicacion
 *
 * @param {string} idCotizacion - El id de la cotización
 * @param {string} idUbicacion - El id de la ubicación
 * @returns {boolean} Resultado de la operación de eliminación
 */
  const eliminarElemento = async (idUbicacion) => {
    console.log('idUbicacion', idUbicacion)
    try {
      setLoading(true)
      // Hace una petición HTTP DELETE a la URL especificada
      const response = await apiGet(`${urlEliminarUbicacionPymes}&idCarrito=${idCarrito}&numUbicacion=${idUbicacion}`);

      // Espera la respuesta en formato JSON
      const data = await response;
      console.log('elementoEliminado', data)
      // Devuelve verdadero si la operación de eliminación fue exitosa
      if (data.transaccion) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      // Imprime el error en la consola
      console.error(error);
      setLoading(false)
      return false;
    }
  };

  const handleRecargo = async (val) => {

    const param = { opciones: opciones }
    console.log('ggg', JSON.stringify(param))
    setLoading(true)
    let url = urlGuardarRecargoPymes.replace('{idCarrito}', idCarrito)
    url = url.replace('{recargo}', val)
    try {
      setCargarRecargo(true)
      let res = await apiPost(url, param)
      setCargarRecargo(false)
      console.log('res:', res)
      if (res.transaccion) {
        setTotales(res.totales)
        setUrlPdf(res.urlPdf)
        setDescuento(val)
        // setError(res.error)
        setPulse(false)
        setdatoCambio('btn btn-primary')
      } else {
        alert('Error al calcular Recago/Descuento')
      }

    } catch (e) {
      setCargarRecargo(false)
    }
    setLoading(false)
  }



  const { carProductos, datosContratante, dataUbicaciones, recargoDescuento } = resumen

  // Corregir lista de llegada de los servicios (recargo descuento)
  // para el componente Select1
  const inputListSlct1 = (inputList) => {
    const formatListSlect1 = []
    for (const idx in inputList) {
      formatListSlect1.push({
        value: inputList[idx].id,
        label: inputList[idx].name
      })
    }
    // return
    return formatListSlect1
  }

  // Corregir items (obj descuento) para el componente Slct1
  const itemSlct1 = (item) => {
    // al inicio el servicio da booleans, y luego numeros en string
    const itemType = typeof (item)
    // validar ambos casos
    let active = false
    const formatedItem = {}
    if (itemType === 'string') {
      active = true
      item = item.toString() // number represented as string
    } else if (itemType === 'boolean') {
      active = true
      item = item ? 1 : 0; // boolean to number
      item = item.toString() // number represented as string
    } else {
      console.error('El tipo de valor del descuento que llega del servicio es incorrecto!')
    }
    // Make the changes so Select1 can accept it
    if (active) {
      formatedItem['value'] = item
      formatedItem['label'] = `${item}%`
    }
    // return
    return formatedItem
  }

  return (
    <LoadingScreen
      loading={loading}
      bgColor="#f1f1f1"
      spinnerColor="#001871"
      textColor="#676767"
      logoSrc={logo}
      text="Cargando..."
      logo={''}
    >
      <div>
        <Row>
          <Col md={8}>
            {!!error && <Alert color="warning">{error}</Alert>}
          </Col>
        </Row>
        <Row>

          <Col md={8} >

            <Card style={{ padding: 10 }}>
              <CardBody>
                <CardTitle> <div style={{ fontWeight: 'bold', fontSize: '1.80rem' }}> Información del contratante </div></CardTitle>
                <Row>
                  <Col md={8} sm={12} >
                    <Row>
                      <Col md={3} > <h4 style={{ fontWeight: 500, }} >Nombre</h4></Col>
                      <Col lg={9} md={6} sm={6} > <div className={"input-type-label form-control"} >{datosContratante.nombre}</div></Col>
                    </Row>
                    <Row>
                      <Col md={3} > <h4 style={{ fontWeight: 500, }} >Cedula / Ruc</h4></Col>
                      <Col md={9} > <div className={"input-type-label form-control"} >{datosContratante.cedula}</div></Col>
                    </Row>
                  </Col>
                  <Col md={4} sm={12} >


                    {
                      ((!deshabilitar) || (deshabilitar && !correoEnviado)) ?
                        actionButtons.map((button) => {
                          return (
                            <React.Fragment>
                              <Col md={3}>
                                <Button
                                  className={button.className}
                                  onClick={() => button.onclick()}>
                                  <i className={button.icon} aria-hidden="true" />{` ${button.title}`}
                                </Button>

                              </Col>
                              <br></br>

                            </React.Fragment>

                          )
                        }) : null}

                    {/*  <Col md={3}>
                      <Button
                        className={"button-white"}
                        onClick={() => onClickEditarUbicacion()}>
                        <i className="fa fa-edit" aria-hidden="true" />{" EDITAR UBICACIÓN"}
                      </Button>
                    </Col>
                    <br></br>
                    <Col md={3} >
                      <Button
                        className={"button-white"}
                        onClick={() => onClickEditarCotizacion()}>
                        <i className="fa fa-edit" aria-hidden="true" />{" EDITAR VALORES COTIZACIÓN"}
                      </Button>
                    </Col>
                    <br></br>
                    <Col md={3} >
                      <Button
                        className={"button-white"}
                        onClick={() => onClickEditarCoberturas()}>
                        <i className="fa fa-edit" aria-hidden="true" />{"AÑADIR/ELIMINAR COBERTURA"}
                      </Button>
                    </Col> */}

                  </Col>
                </Row>



              </CardBody>
            </Card>
            <hr />
            {opciones && opciones.length > 0 && <>
              <Card style={{ padding: 10 }}>
                <CardBody>
                  {opciones.map((item, i) =>
                    <div key={`opcion${i}00`} className="div-align-center" style={{}} >
                      <div className='flex' style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <h5 style={{ fontWeight: "", }}>{item.descripcion}</h5>
                        {console.log(item.value)}
                        <div className='flex' style={{ flexGrow: 0, }}>
                          <Checkbox
                            id={`preguntaSI${i}`} // Optional.[String].Default: "".  Input ID.
                            name={`preguntaSI${i}`}
                            classNameInputBox='check-dos'
                            value={item.value} // Required.[String].Default: "".
                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            checked={!!item.value} // Required.[Bool].Default: false.
                            onChange={(res, e) => { let op = [...opciones]; op[i] = { ...op[i], value: res }; setOpciones(op); setdatoCambio('btn btn-purple fe-pulse ') }}
                            // labelHtml={<div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold", }}> {item.descripcion} </div>} // Required.[Html].Default: none.
                            validationOption={{
                              name: `preguntaSI${i}`, // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            }}
                          />
                        </div>
                      </div>
                    </div>)}
                  <div>
                    <Button disabled={!!error} className={`${datoCambio}`} onClick={() => { /*setValidate(true);*/ handleRecargo(descuento) }} style={{ display: 'block', margin: "0px 0px 0px auto", }} >
                      <i className="fa fa-chevron-circle-right " aria-hidden="true" />{' ACTUALIZAR'}
                    </Button>
                  </div>
                </CardBody>
              </Card>
              <hr /></>
            }

            {!deshabilitar &&
              <EmisionRetroactiva
                ramo={'PYMES'}
                vigenciaRetroactiva={vigenciaRetroactiva}
                mensaje={'¿Se requiere la emisión con una vigencia retroactiva o futura? Por favor seleccionar únicamente en caso de necesitarlo'}
                setVigenciaRetroactiva={(valor) => { setVigenciaRetroactiva(valor) }}
                requiereEmision={requiereEmision}
                setRequiereEmision={(valor) => { setRequiereEmision(valor) }}
                setLoading={(valor) => { setLoading(valor) }}
                ramfecFuturo={ramfecFuturo}
                ramfecRetroactividad={ramfecRetroactividad}
                setRamfecFuturo={(valor) => { setRamfecFuturo(valor) }}
                setRamfecRetroactividad={(valor) => { setRamfecRetroactividad(valor) }}
                errorVigenciaRetroactiva={errorVigenciaRetroactiva}
                setErrorVigenciaRetroactiva={(valor) => { setErrorVigenciaRetroactiva(valor) }}
              />

            }

            {dataUbicaciones && dataUbicaciones.length > 0 && dataUbicaciones.map((data, i) =>
              <Card style={{ padding: 10 }} key={Math.random() + 'wqew'} >
                <CardBody>
                  <CardTitle className="d-flex justify-content-between">
                    <div style={{ fontWeight: 'bold', fontSize: '1.80rem' }}>
                      Ubicación del Bien Asegurado #{i + 1}
                    </div>
                    {dataUbicaciones.length > 1 &&
                      <Button
                        className={"button-white"}
                        style={{ marginRight: "0.2em" }}
                        onClick={() => {
                          setIdUbicacion(i)
                          setModal(true)


                        }}
                      >
                        {" "}
                        <i className="fa fa-trash" aria-hidden="true" /> ELIMINAR
                      </Button>
                    }

                  </CardTitle>
                  <Row>
                    <Col md={6} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Provincia</h4></Col>
                    <Col md={6} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{data.provincia}</div></Col>
                  </Row>
                  <Row>
                    <Col md={6} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Ciudad</h4></Col>
                    <Col md={6} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{data.ciudad}</div></Col>
                  </Row>
                  <Row>
                    <Col md={6} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Canton</h4></Col>
                    <Col md={6} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{data.canton} </div></Col>
                  </Row>
                  <Row>
                    <Col md={6} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Dirección del bien asegurado</h4></Col>
                    <Col md={6} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{data.direccion}</div></Col>
                  </Row>
                </CardBody>
              </Card>
            )}

          </Col>
          <Col md={4} className='detalle-impuestos-box'>
            <Card style={{ padding: 10 }} >
              <CardBody>
                <CardTitle> <div style={{ fontWeight: 'bold', fontSize: '1.80rem', }}> Valor del seguro </div></CardTitle>
                <div className="flex itemDescripcion" style={{ padding: 0, }} > <label> Prima neta </label> ${totales.primaNeta} </div>
                <div className="flex itemDescripcion" style={{ padding: 0, }} > <label> Super intendencia </label> $ {totales.superintendencia} </div>
                <div className="flex itemDescripcion" style={{ padding: 0, }} > <label> Impuesto campesino </label> $ {totales.impCampesino} </div>
                <div className="flex itemDescripcion" style={{ padding: 0, }} > <label> Derechos de Emisión </label> $ {totales.derechoEmision} </div>
                <div className="flex itemDescripcion" style={{ padding: 0, }} > <label> Base imponible </label> $ {totales.baseImponible} </div>
                <div className="flex itemDescripcion" style={{ padding: 0, }} > <label> IVA % </label> $ {totales.iva} </div>


                <div className="flex itemDescripcion" style={{ borderBottom: 'solid 1px #ecedf0', }} > <label style={{ fontWeight: 700, }}> Prima total </label> ${totales.primaTotal} </div>

                {!correoEnviado &&

                  <React.Fragment>

                    <Row className="mb-2 mt-2 d-none">
                      <Col md={7} className={pulse ? 'fe-pulse' : ''} style={pulse ? { color: '#af006e' } : {}}>
                        <h5>Recargo/descuento</h5>
                      </Col>
                      <Col md={4} >
                        <Select1
                          options={inputListSlct1(recargoDescuento)}
                          value={itemSlct1(descuento)}
                          // components={makeAnimated()}
                          onChange={
                            (val, e) => {
                              val = (val.value).toString()
                              handleRecargo(val)
                            }}
                        />
                      </Col>
                    </Row>
                    <hr />

                  </React.Fragment>




                }






                <Button
                  disabled={(deshabilitar && correoEnviado) || (!descuento && !deshabilitar) || !!error || (requiereEmision && errorVigenciaRetroactiva)}
                  //disabled                 
                  className="btn btn-primary "
                  style={{ display: 'block', margin: 'auto', }}
                  //  onClick={() => { }}>
                  onClick={() => {

                    if (deshabilitar) {
                      onSolicitarRecotizacion()
                    } else {
                      onClickContinuar()
                    }

                  }
                  }>
                  <i className="fa fa-chevron-circle-right" aria-hidden="true" />{(deshabilitar) ? ' SOLICITUD DE APROBACIÓN DE COTIZACIÓN' : ` INICIAR EMISIÓN`}
                </Button>

                {true &&
                  <React.Fragment>




                    <a href={urlPdf} target="_blank" className="btn btn-detail-white" style={{ marginTop: 20, pointerEvents: (!!error) ? "none" : "auto", }} >
                      <i className="fa fa-cloud-download" aria-hidden="true" /> DESCARGAR COTIZACIÓN
                    </a>
                    <div className='row' style={{ marginTop: 20, }}>
                      <Col lg={8} md={12} sm={12} xs={12}>
                        <input disabled={!!error} className="form-control" placeholder="Por favor ingrese el correo" value={correo} onChange={({ target }) => setCorreo(target.value)}>
                        </input>
                        {msjEmail && <Alert color="danger">
                          Ingrese correctamente el correo electrónico.
                        </Alert>}
                      </Col>
                      <Col lg={4} md={12} sm={12} xs={12}>
                        <Button disabled={!!error} className="btn btn-detail-white" onClick={() => enviarEmail()}>
                          <i className="fa fa-paper-plane-o" aria-hidden="true" /> ENVIAR
                        </Button>

                      </Col>
                      {mensaje &&
                        <Alert color="success">
                          <center><p>Se ha enviado correctamente la cotización al correo electrónico ingresado.</p></center>
                        </Alert>
                      }
                    </div>


                  </React.Fragment>
                }



              </CardBody>
            </Card>
          </Col>
        </Row>

      </div>
      <ConfirmationModal
        title="Confirmación"
        body={`¿Estás seguro de que deseas eliminar la ubicación ${idUbicacion + 1}?`}
        modal={modal}
        setModal={(value) => { setModal(value) }}
        buttons={
          [
            {
              title: " Eliminar",
              className: 'secondary',
              onclick: async () => {

                const elementoEliminado = await eliminarElemento(idUbicacion)
                console.log('elementoEliminado', elementoEliminado)
                if (elementoEliminado) {
                  window.location.reload();

                } else {


                }

                setModal(false)
              },
              icon: 'fa fa-trash'
            },
            {
              title: " Cancelar",
              className: 'button-white',
              onclick: async () => {
                setModal(false)
              },
              icon: 'fa fa-edit'
            }
          ]
        }
      />
    </LoadingScreen >

  )
}

export default Resumen